import {Controller} from '@hotwired/stimulus'

// Submits an input's form when the input changes, for a choice the server
// answers by re-rendering the page (GF-3909: the consent holder picker).
export default class extends Controller {
  // eslint-disable-next-line class-methods-use-this
  submit(event) {
    event.target.form.requestSubmit()
  }
}
